import style from './AdminNoteConnected.module.scss';
import MainLayout from '@/components/MainLayout';
import AdminSidebar from '@/components/AdminSidebar';
import SelectClinician from '@/components/SelectClinician';
import {
  navigationSlice,
  selectCurrentSection,
  useAppDispatch,
  selectProviderUserSettings,
  useAppSelector,
  selectIsProviderAdmin,
} from '@ax/redux-store';
import rightCaret from '@image/right-caret.svg';
import Visits from '@/modules/Visits';
import NoteInfo from '@/modules/NoteInfo';
import Tabs from '@/components/Tabs';
import Note from '@/modules/Note';
import { NotePageSections } from '@ax/constants';
import { TAB_NAME } from '@/constants/tabs-constants.ts';
import { useEffect } from 'react';
import Transcript from '@/modules/Transcript';

export default function AdminNoteConnected() {
  const activeTab = useAppSelector(selectCurrentSection);
  const selectedVisit = useAppSelector((state) => state.selectedVisit);
  const dispatch = useAppDispatch();
  const providerSettings = useAppSelector(selectProviderUserSettings);
  const isProviderAdmin = useAppSelector(selectIsProviderAdmin);

  const tabItems = [
    {
      id: NotePageSections.Transcript,
      title: TAB_NAME.TRANSCRIPT,
      component: <Transcript readonly={isProviderAdmin} />,
    },
  ];

  useEffect(() => {
    if (providerSettings && activeTab) {
      const isActiveTabAvailable = tabItems.find((tab) => tab.id === activeTab);
      if (!isActiveTabAvailable) {
        dispatch(
          navigationSlice.actions.sectionNavigationRequested({
            section: tabItems[0].id,
            noteId: selectedVisit?.uuid,
          }),
        );
      }
    }
  }, [activeTab, providerSettings, selectedVisit]);

  return (
    <MainLayout
      sideBarContent={<AdminSidebar sideBarContent={<Visits readonly={!!isProviderAdmin} />} />}
      mainContent={
        <>
          <div className="flex border-b border-solid border-gray-300">
            <div className="flex flex-grow basis-1/2 justify-start items-center pl-4">
              <form>
                <div className={style.select__styles}>
                  <SelectClinician />
                </div>
              </form>
              <div className={style.arrow__styles}>
                <img
                  src={rightCaret}
                  height={18}
                />
              </div>
              <NoteInfo />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
            <div className="border-r border-solid border-gray-300">
              <Tabs
                activeItem={activeTab}
                onItemSelect={(section) => {
                  dispatch(
                    navigationSlice.actions.sectionNavigationRequested({
                      section,
                      noteId: selectedVisit?.uuid,
                    }),
                  );
                }}
                items={tabItems}
              />
            </div>
            <Note readonly={isProviderAdmin} />
          </div>
        </>
      }
    />
  );
}
